import React from 'react';
import type { SnapLine, SelectionRectState } from './types';

export interface CanvasOverlaysProps {
  selectionRect: SelectionRectState | null;
  snapLines: SnapLine[];
}

// ── Component ─────────────────────────────────────────────────────────────────

const CanvasOverlays = React.memo(function CanvasOverlays({ selectionRect, snapLines }: CanvasOverlaysProps) {
  return (
    <>
      {/* Selection rectangle */}
      {selectionRect && (
        <rect
          x={Math.min(selectionRect.startX, selectionRect.currentX)}
          y={Math.min(selectionRect.startY, selectionRect.currentY)}
          width={Math.abs(selectionRect.currentX - selectionRect.startX)}
          height={Math.abs(selectionRect.currentY - selectionRect.startY)}
          fill="rgba(59, 130, 246, 0.1)"
          stroke="#3b82f6"
          strokeWidth="2"
          strokeDasharray="5,5"
          className="pointer-events-none"
        />
      )}

      {/* Snap lines for alignment guides */}
      {snapLines.map((line, idx) => {
        if (line.type === 'vertical') {
          return (
            <line
              key={idx}
              x1={line.x} y1={line.y1}
              x2={line.x} y2={line.y2}
              stroke="#ff6b35"
              strokeWidth="1.5"
              strokeDasharray="4,4"
              className="pointer-events-none"
            />
          );
        }
        if (line.type === 'horizontal') {
          return (
            <line
              key={idx}
              x1={line.x1} y1={line.y}
              x2={line.x2} y2={line.y}
              stroke="#ff6b35"
              strokeWidth="1.5"
              strokeDasharray="4,4"
              className="pointer-events-none"
            />
          );
        }
        if (line.type === 'equidistance-h') {
          const tickH = 8;
          return (
            <g key={idx} className="pointer-events-none">
              <line x1={line.x1} y1={line.y} x2={line.x2} y2={line.y} stroke="#10b981" strokeWidth="1.5" />
              <line x1={line.x1} y1={line.y - tickH / 2} x2={line.x1} y2={line.y + tickH / 2} stroke="#10b981" strokeWidth="1.5" />
              <line x1={line.xMid} y1={line.y - tickH / 2} x2={line.xMid} y2={line.y + tickH / 2} stroke="#10b981" strokeWidth="1.5" />
              <line x1={line.x2} y1={line.y - tickH / 2} x2={line.x2} y2={line.y + tickH / 2} stroke="#10b981" strokeWidth="1.5" />
            </g>
          );
        }
        if (line.type === 'equidistance-v') {
          const tickW = 8;
          return (
            <g key={idx} className="pointer-events-none">
              <line x1={line.x} y1={line.y1} x2={line.x} y2={line.y2} stroke="#10b981" strokeWidth="1.5" />
              <line x1={line.x - tickW / 2} y1={line.y1} x2={line.x + tickW / 2} y2={line.y1} stroke="#10b981" strokeWidth="1.5" />
              <line x1={line.x - tickW / 2} y1={line.yMid} x2={line.x + tickW / 2} y2={line.yMid} stroke="#10b981" strokeWidth="1.5" />
              <line x1={line.x - tickW / 2} y1={line.y2} x2={line.x + tickW / 2} y2={line.y2} stroke="#10b981" strokeWidth="1.5" />
            </g>
          );
        }
        return null;
      })}

      {/* Arrow marker definitions */}
      <defs>
        <marker id="ah" markerWidth="10" markerHeight="10" refX="9" refY="3" orient="auto">
          <polygon points="0 0, 10 3, 0 6" fill="#3b82f6" />
        </marker>
        <marker id="ah-cp" markerWidth="10" markerHeight="10" refX="9" refY="3" orient="auto">
          <polygon points="0 0, 10 3, 0 6" fill="#ef4444" />
        </marker>
      </defs>
    </>
  );
});

export default CanvasOverlays;
